export const AD_TYPE = {
  MREC: 'MREC',
  OVERLAY: 'OVERLAY',
  VPAID: 'VPAID',
  VAST: 'VAST',
  IMA: 'IMA',
  TAPPX_PREBID: 'TAPPX_PREBID',
  PREBID: 'PREBID',
  VIDEO_DIRECTO: 'VIDEODIRECTO',
  VIDEO_INSTREAM: 'VIDEO_INSTREAM',
  VIDEO_OUTSTREAM: 'VIDEO_OUTSTREAM',
  VIDEO_MREC: 'VIDEO_MREC',
};

export default AD_TYPE;
